import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ImageService } from './image.service';

@Pipe({
  standalone: true,
  name: 'secure',
})
export class SecurePipe implements PipeTransform {
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);
  private imageService = inject(ImageService);

  transform(url: string | null | undefined): Observable<SafeUrl | null> {
    if (!url) return of(null);

    if (this.isLocalAssetUrl(url)) {
      return of(this.sanitizer.bypassSecurityTrustUrl(url));
    }

    const index = this.imageService.cachedImages.findIndex(
      cachedImage => cachedImage.url === url
    );

    if (index > -1) {
      const image = this.imageService.cachedImages[index];
      if (!image?.blob) return of(null);
      return of(
        this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(image.blob))
      );
    }

    return this.http
      .get(url, {responseType: 'blob', withCredentials: true})
      .pipe(
        tap((blob: Blob) => this.imageService.checkAndCacheImage(url, blob)),
        map(val =>
          this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))
        )
      );
  }

  private isLocalAssetUrl(url: string): boolean {
    return !url.startsWith('http://') && !url.startsWith('https://');
  }
}
